var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1992 13.6367L10.1367 19.2617C9.92578 19.5078 9.57422 19.5078 9.36328 19.2969C9.11719 19.0859 9.11719 18.7344 9.32812 18.5234L14.0391 13.25L9.32812 8.01172C9.11719 7.80078 9.11719 7.44922 9.36328 7.23828C9.57422 7.02734 9.92578 7.02734 10.1367 7.27344L15.1992 12.8633C15.4102 13.1094 15.4102 13.4258 15.1992 13.6367Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight);
export default __webpack_public_path__ + "static/media/AngleRight.4ec8fa73e67e8fb5f91537913fd12d5e.svg";
export { ForwardRef as ReactComponent };